module.exports = __webpack_public_path__ + "img/11_b.06ec7490.jpg";